import React, {Component} from 'react';
import {FormControl, Icon, TextField} from '@material-ui/core';

class UecareTextarea extends Component {

    render() {

        return (
            <div className="flex">
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>
                <FormControl className={this.props.className} fullWidth>
                    {
                        <TextField
                            label={this.props.label}
                            id={this.props.id}
                            name={this.props.name}
                            value={this.props.value}
                            onChange={this.props.onChange}
                            disabled={this.props.disabled}
                            multiline
                            rows={2}
                            rowsMax={10}
                        />
                    }
                </FormControl>
            </div>
        );
    }
}

export default UecareTextarea;



// WEBPACK FOOTER //
// ./src/components/UecareTextarea.js